import React, { Component } from 'react';
import * as lang from './../../lang.js';
import * as ajax from './../../ajax.js';

import '@inovua/reactdatagrid-community/index.css';
import '@inovua/reactdatagrid-community/base.css';

import '@inovua/reactdatagrid-community/theme/default-dark.css';
import '@inovua/reactdatagrid-community/theme/default-light.css';

import ReactDataGrid from '@inovua/reactdatagrid-community';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter'



import PagingToolbar from './../../components/PagingToolbar';

import {Button} from 'react-bootstrap';

import InsertForm from './ArajanlatTetelInsertForm.js';
import UpdateForm from './ArajanlatTetelUpdateForm.js';
import ViewForm from './ArajanlatTetelViewForm.js';
import Dialog from './../../components/Dialog.js';
import ActionCell from './../../components/ActionCell';
import FormatedNumberCell from './../../components/FormatedNumberCell';

import moment from 'moment';
import 'moment/locale/hu';
moment().locale('hu');



class ArajanlatTetelTable extends Component {

    constructor(props) {
        super(props);

        this.NONE = "NONE";

        this.FORM_DELETE = "DELETE";
        this.FORM_INSERT = "INSERT";
        this.FORM_UPDATE = "UPDATE";
        this.FORM_VIEW = "VIEW";


        this.DIALOG_INFO = "INFO";
        this.DIALOG_ALERT = "ALERT";
        this.DIALOG_CONFIRMATION = "CONFIRMATION";
        var columnNames = [
            'action_cell',
            'arajanlatTetelek_id',
            'arajanlatTetelek_manualis_tetel_sorszam',
            'arajanlatTetelek_arajanlat_id',
            'arajanlatTetelek_megnevezes',
            'arajanlatTetelek_hivatkozas_megjegyzes',
            'arajanlatTetelek_hivatkozas',
            'arajanlatTetelek_netto_ar',
            'arajanlatTetelek_darabszam',
            'arajanlatTetelek_mennyisegiEgyseg',
            'arajanlatTetelek_nettoOsszesen',

            'arajanlatTetelek_eredeti_netto_ar',
            'opcionalis_tetelek_osszesen',
            'arajanlatTetelek_tetel_kibontas'];
        this.columnStateHandler = ajax.columnStateHandler(columnNames, "ArajanlatTetel", "arajanlatTetelek");

        this.state = {
            columnOrder: columnNames,
            theme: this.props.theme,
            openedForm: this.NONE, // DELETE,INSERT,UPDATE,VIEW
            defaultUpdateBlocked: false,
            selectedRow: null,
            sortInfo: null,
            groupBy: false,
            filterValue: null,
            additionalParams: [],
            requestProps: null,
            skip: 0,
            paging: {
                totalPageCount: 0,
                currentPage: 0,
                pageRowCount: 100000,
                showingRowFrom: 0,
                showingRowTo: 100000,
                totalRowCount: 0,
                skip: 0
            },
            dialogType: this.NONE,
            dialogText: ''
        };
        this.renderPaginationToolbar = null;
        this.ref = React.createRef();

        this.currentArajanlatId = -1;
        this.prevArajanlatId = -1;

    }

    getArrajanlatIdFromAdditionalParams = function (props) {
        if (typeof props == 'undefined') {
            return -1;
        }
        if (props == null) {
            return -1;
        }
        if (typeof props.additionalParams == 'undefined') {
            return -1;
        }
        if (props.additionalParams == null) {
            return -1;
        }
        if (props.additionalParams.length == 0) {
            return -1;
        }

        if (typeof props.additionalParams[0].arajanlatTetelek_arajanlat_id == 'undefined') {
            return -1;
        }
        if (props.additionalParams[0].arajanlatTetelek_arajanlat_id == null) {
            return -1;
        }

        return props.additionalParams[0].arajanlatTetelek_arajanlat_id;

    }

    componentDidUpdate(prevProps) {
        if (prevProps.theme !== this.props.theme) {
            this.setState({theme: this.props.theme});
        }
    }

    shouldComponentUpdate(nextProps, nextState) {

        var currentArajanlatId = this.getArrajanlatIdFromAdditionalParams(this.props);

        if (currentArajanlatId != this.currentArajanlatId) {
            this.currentArajanlatId = currentArajanlatId;
            return true;
        } else {
            return false;
        }

        return true;
    }

    setView = function (e) {

        var formName = e.target.id;

        var rowSelectionNeed = false;
        var hasSelectedRow = true;

        if (formName == this.FORM_DELETE || formName == this.FORM_UPDATE || formName == this.FORM_VIEW) {
            rowSelectionNeed = true;
        }
        if (this.state.selectedRow == null || this.state.selectedRow == '') {
            hasSelectedRow = false;
        }
        if (rowSelectionNeed == true && hasSelectedRow == false) {
            this.setState({openedForm: this.DIALOG_ALERT, dialogText: lang.getTitle("ROW_SELECTION_NEED")});
        } else {
            var dialogText = "";
            if (formName == this.FORM_DELETE) {
                dialogText = lang.getTitle("DELETE_CONFIRMATION");
            }
            this.setState({openedForm: formName, dialogText: dialogText});
        }

        this.forceUpdate();

    }

    closeForm = function () {
        this.setState({openedForm: this.NONE});
        this.forceUpdate();
    }

    customPaging = function (pagingProps) {
        return <PagingToolbar blackTheme={this.props.theme} tableReload={this.reload.bind(this)} paging={this.state.paging} />
    }
    reload = function (skip) {
        this.state.paging.skip = skip;
        this.forceUpdate();
    }

    concatAdditionalParams = function () {
        // var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                this.state[property] = additionalParam[property];
            }
        }

        return this.state;
    }

    addForeignKeyFilter = function (filterValues) {

        var additionalParams = this.props.additionalParams;

        if (typeof additionalParams == 'undefined') {
            return filterValues;
        }

        if (additionalParams == null) {
            return filterValues;
        }

        if (additionalParams.length == null) {
            return filterValues;
        }

        for (var ap = 0; ap < additionalParams.length; ap++) {

            var additionalParam = additionalParams[ap];

            for (const property in additionalParam) {

                var filter = null;
                for (var f = 0; f < filterValues.length; f++) {
                    var currentFilter = filterValues[f];
                    if (currentFilter.name == property) {
                        filter = currentFilter;
                    }
                }

                if (filter != null) {
                    filter.operator = 'eq';
                    filter.type = 'number';
                    filter.value = additionalParam[property];
                } else {
                    filter = {
                        name: property,
                        operator: 'eq',
                        type: 'number',
                        value: additionalParam[property]
                    };
                    filterValues.push(filter);
                }
            }

        }
        return filterValues;
    }

    dataLoader = function ( { skip, limit, sortInfo, groupBy, filterValue }){
        this.state.paging.skip = (typeof this.state.paging.skip == 'undefined') ? 0 : this.state.paging.skip;
        var state = this.state;
        filterValue = this.addForeignKeyFilter(filterValue);
        var self = this;

        this.state.requestProps = {skip: state.paging.skip, limit: limit, sortInfo: sortInfo, filterValue: filterValue};
        try {
            const url = ajax.getUrlBase() + "modules/ArajanlatTetel/arajanlatTetelekTableSelect.php";
            state.update = false;
            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({skip: state.paging.skip, limit: limit, sortInfo: sortInfo, filterValue: filterValue})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        self.defaultUpdateBlocked = false;
                        var totalCount = response.count;
                        var data = response.data;
                        state.paging.totalRowCount = totalCount;
                        var totalPageCount = ((totalCount) / state.paging.pageRowCount);
                        state.paging.totalPageCount = Math.ceil(totalPageCount) - 1;
                        state.paging.showingRowFrom = skip;
                        state.paging.showingRowTo = skip + state.pageRowCount;
                        if (typeof self.props.forceReload != 'undefined') {
                            self.props.forceReload();
                        }
                        return Promise.resolve({data, count: parseInt(totalCount), skip: state.paging.skip});
                    }).catch(function (jsonError) {
                        self.defaultUpdateBlocked = false;
                        if (null == jsonError) {

                            console.error("Fetch JSON error:");
                        } else {
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    state.defaultUpdateBlocked = false;
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                state.defaultUpdateBlocked = false;
                console.error("Fetch error:", error);
                if (null == error) {
                    console.error("Fetch error:");
                } else {
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            state.defaultUpdateBlocked = false;
            console.error("Fetch exception:", String(ex));
    }
    }

    delete = function () {

        var state = this.state;
        var self = this;
        try {
            const url = ajax.getUrlBase() + "modules/ArajanlatTetel/arajanlatTetelekFormDelete.php";
            state.update = false;
            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({arajanlatTetelek_id: this.state.selectedRow})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success == true) {
                            self.setState({openedForm: 'HIDDEN', selectedRow: null});
                        } else {
                            self.setState({openedForm: this.DIALOG_ALERT, dialogText: response.fail});
                        }
                        this.forceUpdate();
                    }).catch(function (jsonError) {
                        self.defaultUpdateBlocked = false;
                        if (null == jsonError) {

                            console.error("Fetch JSON error:");
                        } else {
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    self.defaultUpdateBlocked = false;
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                self.defaultUpdateBlocked = false;
                console.error("Fetch error:", error);
                if (null == error) {
                    console.error("Fetch error:");
                } else {
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            self.defaultUpdateBlocked = false;
            console.error("Fetch exception:", String(ex));
        }
    }

    onSelectionChange = function (selection) {
        this.setState({selectedRow: selection.selected});
    }

    onRowClick = function (rowProps, event) {

        if (typeof rowProps == 'undefined') {
            return false;
        }

        if (rowProps == null) {
            return false;
        }

        if (typeof rowProps.data == 'undefined') {
            return false;
        }

        if (rowProps.data == null) {
            return false;
        }

        if (typeof rowProps.data.arajanlatTetelek_id == 'undefined') {
            return false;
        }

        if (rowProps.data.arajanlatTetelek_id == null) {
            return false;
        }
        this.setState({selectedRow: rowProps.data.arajanlatTetelek_id});
    }

    hasSelectedRow = function () {
        if (typeof this.state.selectedRow == 'undefined') {
            return false;
        }
        if (this.state.selectedRow == null) {
            return false;
        }


        if (this.state.selectedRow == -1) {
            return false;
        }
        return true;
    }

    isViewForm = function () {

        if (typeof this.props.formType == 'undefined') {
            return false;
        }
        if (this.props.formType == null) {
            return false;
        }
        if (this.props.formType == '') {
            return false;
        }
        if (this.props.formType == this.FORM_VIEW) {
            return true;
        }
        return false;
    }

    onColumnVisibleChange = function ( { column, visible }){
        this.columnStateHandler.storColumnVisibility(column.name, visible);
        this.forceUpdate();

    }

    render() {

        var isViewForm = this.isViewForm();
        var columns = [
            {
                name: 'action_cell', header: '', minWidth: 160,
                render: ({ value, data }) => {
                    return <ActionCell 
                        stateReference ={this.state}
                        row_id={data.arajanlatTetelek_id}   
                        setView={this.setView.bind(this)}
                        isViewForm ={isViewForm}
                        theme={this.props.theme}
                        />
                },
                sortable: false
            },

            {name: 'arajanlatTetelek_id', sortable: true, header: lang.getTitle('arajanlatTetelek_id'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_id', 150), type: 'number', filterEditor: NumberFilter, defaultVisible: true}
            , {name: 'arajanlatTetelek_manualis_tetel_sorszam', sortable: true, header: lang.getTitle('arajanlatTetelek_manualis_tetel_sorszam'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_manualis_tetel_sorszam', 150), type: 'number', filterEditor: NumberFilter, defaultVisible: true}
            , {name: 'arajanlatTetelek_arajanlat_id', sortable: true, header: lang.getTitle('arajanlatTetelek_arajanlat_id'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_arajanlat_id', 150), type: 'number', filterEditor: NumberFilter, defaultVisible: false}
            , {name: 'arajanlatTetelek_megnevezes', sortable: true, header: lang.getTitle('arajanlatTetelek_megnevezes'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_megnevezes', 150), defaultVisible: true}
            , {name: 'arajanlatTetelek_hivatkozas_megjegyzes', sortable: true, header: lang.getTitle('arajanlatTetelek_hivatkozas_megjegyzes'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_hivatkozas_megjegyzes', 150), defaultVisible: true}
            , {name: 'arajanlatTetelek_hivatkozas', sortable: true, header: lang.getTitle('arajanlatTetelek_hivatkozas'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_hivatkozas', 150), defaultVisible: true}
            , {name: 'arajanlatTetelek_netto_ar', sortable: true, header: lang.getTitle('arajanlatTetelek_netto_ar'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_netto_ar', 150), type: 'number', filterEditor: NumberFilter, defaultVisible: true,
                render: ({ value, cellProps }) => {
                    return <FormatedNumberCell value={value} />
                }

            }
            , {name: 'arajanlatTetelek_eredeti_netto_ar', sortable: true, header: lang.getTitle('arajanlatTetelek_eredeti_netto_ar'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_eredeti_netto_ar', 150), type: 'number', filterEditor: NumberFilter, defaultVisible: true,
                render: ({ value, cellProps }) => {
                    return <FormatedNumberCell value={value} />
                }

            },
            {name: 'arajanlatTetelek_darabszam', sortable: true, header: lang.getTitle('arajanlatTetelek_darabszam'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_darabszam', 150), type: 'number', filterEditor: NumberFilter, defaultVisible: true,
                render: ({ value, cellProps }) => {
                    return <FormatedNumberCell value={value} />
                }
            },
            {name: 'arajanlatTetelek_mennyisegiEgyseg', sortable: true, header: lang.getTitle('arajanlatTetelek_mennyisegiEgyseg'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_mennyisegiEgyseg', 150), defaultVisible: true,
                render: ({ value, cellProps }) => {
                    return <div>{value} </div>
                }
            },
            {name: 'arajanlatTetelek_nettoOsszesen', sortable: true, header: lang.getTitle('arajanlatTetelek_nettoOsszesen'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_nettoOsszesen', 150), type: 'number', filterEditor: NumberFilter, defaultVisible: true,
                render: ({ value, cellProps }) => {
                    return <FormatedNumberCell value={value} />
                }
            }
            , {name: 'opcionalis_tetelek_osszesen', sortable: false, header: lang.getTitle('opcionalis_tetelek_osszesen'), defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_netto_ar', 150), type: 'number', defaultVisible: true,
                render: ({ value, cellProps }) => {
                    return <FormatedNumberCell value={value} />
                }

            }

            , {name: 'arajanlatTetelek_tetel_kibontas', sortable: true, header: lang.getTitle('arajanlatTetelek_tetel_kibontas'), filterDelay: 1000, defaultWidth: this.columnStateHandler.getColumnWidth('arajanlatTetelek_tetel_kibontas', 150), defaultVisible: false}

        ];

        const filters = [
            {name: 'arajanlatTetelek_id', operator: 'eq', type: 'number', value: ''}
            , {name: 'arajanlatTetelek_manualis_tetel_sorszam', operator: 'eq', type: 'number', value: ''}
            , {name: 'arajanlatTetelek_arajanlat_id', operator: 'eq', type: 'number', value: ''}
            , {name: 'arajanlatTetelek_megnevezes', operator: 'contains', type: 'string', value: ''}
            , {name: 'arajanlatTetelek_hivatkozas_megjegyzes', operator: 'contains', type: 'string', value: ''}
            , {name: 'arajanlatTetelek_hivatkozas', operator: 'contains', type: 'string', value: ''}
            , {name: 'arajanlatTetelek_netto_ar', operator: 'eq', type: 'number', value: ''}
            , {name: 'arajanlatTetelek_darabszam', operator: 'eq', type: 'number', value: ''}
            , {name: 'arajanlatTetelek_mennyisegiEgyseg', operator: 'eq', type: 'number', value: ''}
            , {name: 'arajanlatTetelek_nettoOsszesen', operator: 'eq', type: 'number', value: ''}

            , {name: 'arajanlatTetelek_tetel_kibontas', operator: 'contains', type: 'string', value: ''}

        ]

        columns = this.columnStateHandler.setColumnsVisibility(columns);

        var openedForm = "";
        if (this.state.openedForm == this.FORM_VIEW) {
            openedForm = <ViewForm theme={this.props.theme} key={'arajanlatTetelek_KEY_VIEW'} formType={this.FORM_VIEW} additionalParams={[{arajanlatTetelOpciok_arajanlat_tetel_id: this.state.selectedRow}]} id={this.state.selectedRow} closeForm={this.closeForm.bind(this)} />
        }

        if (this.state.openedForm == this.FORM_INSERT) {
            openedForm = <InsertForm  
                theme={this.props.theme} 
                key={'arajanlatTetelek_KEY_INSERT'} 
                formType={this.FORM_INSERT} 
                additionalParams={[{arajanlatTetelOpciok_arajanlat_tetel_id: this.state.selectedRow}, this.props.additionalParams[0]]} 
                closeForm={this.closeForm.bind(this)} 
                arajanlat_arengedmeny={this.props.arajanlat_arengedmeny}
                forceReload={this.props.forceReload}
                />
        }

        if (this.state.openedForm == this.FORM_UPDATE) {

            var hasSelectedRow = this.hasSelectedRow();
            if (hasSelectedRow == true) {
                openedForm = <UpdateForm 
                    theme={this.props.theme} key={'arajanlatTetelek_KEY_UPDATE'} 
                    formType={this.FORM_UPDATE} 
                    additionalParams={[{arajanlatTetelOpciok_arajanlat_tetel_id: this.state.selectedRow}]} 
                    id={this.state.selectedRow} 
                    closeForm={this.closeForm.bind(this)} 
                    arajanlat_arengedmeny={this.props.arajanlat_arengedmeny}
                    forceReload={this.props.forceReload}
                    />
            } else {
                console.log("Nincs kiválasztott sor");
                // Alert window
            }
        }

        if (this.state.openedForm == this.FORM_DELETE) {
            openedForm = <Dialog 
                type={this.DIALOG_CONFIRMATION} 
                dialogText={this.state.dialogText} 
                callback={this.delete.bind(this)}
                cancel={() => this.setView({target: {id: this.NONE}})}
            
                theme={this.props.theme}
                />;
        }
        if (this.state.openedForm == this.DIALOG_ALERT) {
            openedForm = <Dialog 
                type={this.DIALOG_ALERT} 
                dialogText={this.state.dialogText} 
                callback={() => this.setView({target: {id: this.NONE}})}
                theme={this.props.theme}
                />;
        }


        if (this.renderPaginationToolbar == null) {
            this.renderPaginationToolbar = this.customPaging.bind(this)
        }

        var buttons = [];

        var viewButton = <div  key={'arajanlatTetelek_KEY_VIEW_BUTTON'} >&nbsp;<Button className={'btn-sm'} id={this.FORM_VIEW} onClick={this.setView.bind(this)} variant="info">{lang.getTitle('View')}</Button></div>;
        var insertButton = <div key={'arajanlatTetelek_KEY_INSERT_BUTTON'}>&nbsp;<Button className={'btn-sm'} id={this.FORM_INSERT} onClick={this.setView.bind(this)} variant="success">{lang.getTitle('Insert')}</Button></div>;
        var updateButton = <div key={'arajanlatTetelek_KEY_UPDATE_BUTTON'}>&nbsp;<Button className={'btn-sm'} id={this.FORM_UPDATE} onClick={this.setView.bind(this)} variant="warning">{lang.getTitle('Update')}</Button></div>;
        var deleteButton = <div key={'arajanlatTetelek_KEY_DELETE_BUTTON'}>&nbsp;<Button className={'btn-sm'} id={this.FORM_DELETE} onClick={this.setView.bind(this)} variant="danger">{lang.getTitle('Delete')}</Button></div>;

        var isViewForm = this.isViewForm();

        if (isViewForm) {
            buttons = [viewButton];
        } else {
            buttons = [viewButton, insertButton, updateButton, deleteButton];
        }
        var theme = (this.props.theme == "true") ? 'default-dark' : 'default-light';

        return (
                <div id="ArajanlatTetelTable">
                    <div style={{display: "flex"}}>
                        {buttons}
                    </div>
                    <ReactDataGrid 
                        idProperty="arajanlatTetelek_id" 
                        i18n={ajax.getI18n()}
                        columns={this.columnStateHandler.myColumnsReorder(columns)}
                        dataSource={this.dataLoader.bind(this)}
                        defaultFilterValue={filters}
                        enableSelection={true}
                
                        onRowClick={this.onRowClick.bind(this)}
                        onSelectionChange={this.onSelectionChange.bind(this)}
                        theme={theme}
                
                        style={{minHeight: '100vh'}}
                        defaultLimit={100000}
                        pagination={false}
                        renderPaginationToolbar={this.renderPaginationToolbar}
                        skip={this.state.skip}
                        limit={this.state.paging.pageRowCount}
                
                        onColumnResize={this.columnStateHandler.onColumnResize.bind(this)}  
                        onColumnOrderChange={this.columnStateHandler.onColumnOrderChange.bind(this)}
                        onColumnVisibleChange={this.onColumnVisibleChange.bind(this)}
                
                        />
                    {openedForm}            
                </div>
                );
    }
}

export default ArajanlatTetelTable;
